import React from "react";

export function Skeleton({ className = "", ...props }) {
  return (
    <div
      className={`bg-white/[0.04] rounded-md animate-shimmer ${className}`}
      {...props}
    />
  );
}

export default Skeleton;
